import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import * as autocompleteActions from 'reduxBits/autocomplete/actions'
import * as searchParamsActions from 'reduxBits/searchParams/actions'
import { renderDataLayerObject } from 'tracking/dataLayerUtils'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    // No globals needed
    ...{
      objectCustom: undefined,
      event: 'event',
      eventType: 'Engagement',
      objectType: 'UIElement',
    },
    ...localData,
  })

export const cancelledSearch = {
  validators: [validators.redux(autocompleteActions.CANCEL_SEARCH)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectId: 'cancel_search',
        objectName: 'cancel_search',
      }),
    ),
  ],
}

export const searchResultDescriptionClicked = {
  validators: [validators.redux(searchParamsActions.SEARCH_RESULT_DESCRIPTION_CLICKED)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectId: 'search_result_description',
        objectName: 'search_result_description',
      }),
    ),
  ],
}
